import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const AboutPage = () => (
  <Layout>
    <SEO title="Vue Vixens Foundation" />
    <h1>About the Vue Vixens</h1>
    <p>We're gonna knock your socks clean off!</p>
  </Layout>
)

export default AboutPage
